












import { Vue, Component, Prop, Model, Emit } from "vue-property-decorator";
import { Subject } from "rxjs";
import { Environment } from '@/environments/environment';

@Component({
})
export default class AppHeaderMenus extends Vue {

  /**
   * 是否显示
   *
   * @type {boolean}
   * @memberof AppHeaderMenus
   */
  public isShow:boolean = Environment.devMode;
  
  /**
   * 菜单数据
   * 
   * @type {any}
   * @memberof AppHeaderMenus
   */
  public menus:any = [

  ];

  /**
   * 触发界面行为
   * 
   * @memberof AppHeaderMenus
   */
  public openWindow(menu:any){
      window.open(menu.url, '_blank');
  }


}
